import React, { useState, useMemo } from "react";
import { useUserContext } from "../../../../context/user/UserContext";
import { getOneUser } from "../../../../middlewares/sysNavigation/SysNavigation";
import { validatePassword } from "../../../../controllers/user/userControllers";
import {
  Title,
  GoBack,
  MyMessage,
  InputField,
  PhoneInput,
  MyActionButton,
} from "../../component/Component";
import {
  AiOutlineEye,
  AiOutlineEyeInvisible,
  AiOutlineReload,
  AiOutlineCopy,
  AiOutlineCheck,
  AiOutlineClose,
  AiOutlineWarning,
} from "react-icons/ai";

const Edit = () => {
  const { updateUserProfile, updateUserPassword, updateUserState } = useUserContext();

  const user = getOneUser();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const [error2, setError2] = useState(false);
  const [success2, setSuccess2] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [message2, setErrorMessage2] = useState("");

  const user_id = user.user_id;

  const [firstName, setFirstName] = useState(user.first_name);
  const [lastName, setLastName] = useState(user.last_name);
  const [phone, setPhone] = useState(user.phonenumber);
  const [email, setPrice] = useState(user.email);
  const [password, setPassword] = useState("");
  const [confirm_password, setConfirmPassword] = useState("");

  const userRoutes = "/user";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
  };

  const cleanPasswordFields = () => {
    setLoading2(false);
    setSuccess2(true);
  };

  const responsesPassword = (isError, _status, _message) => {
    setError2(isError);
    setErrorMessage2(_message);
  };

  const responses = (isError, _status, _message) => {
    setError(isError);
    setErrorMessage(_message);
  };

  const updatePasswordHandler = async (e) => {
    e.preventDefault();
    setLoading2(true);

    const validation = validatePassword(password, confirm_password);
    if (validation.isError) {
      setLoading2(false);
      responsesPassword(validation.isError, validation.status, validation.message);
    } else if (password !== confirm_password) {
      setLoading2(false);
      responsesPassword(true, 400, "Passwords Should Match");
    } else {
      await sendDBPasswordRequest();
    }
  };

  const updateOneUserHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!firstName || firstName === "") {
      responses(true, 400, "First Name is required");
    } else if (!lastName || lastName === "") {
      responses(true, 400, "Last Name is required");
    } else if (!email || email === "") {
      responses(true, 400, "Email is required");
    } else if (!phone || phone === "") {
      responses(true, 400, "Phone is required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBPasswordRequest = async () => {
    const data = { password: password };
    const { status, message } = await updateUserPassword(user_id, data);
    if (status === 200) {
      cleanPasswordFields();
      responsesPassword(false, status, message);
      setPassword("");
      setConfirmPassword("");
    } else {
      setLoading2(false);
      responsesPassword(true, status, message);
    }
  };

  const sendDBRequest = async () => {
    const data = {
      first_name: firstName,
      last_name: lastName,
      phonenumber: phone,
      email: email,
    };

    const { status, message } = await updateUserProfile(user_id, data);
    if (status === 200) {
      updateUserState({ user_id, ...data });
      cleanFields();
      responses(true, status, message);
    } else {
      setLoading(false);
      responses(true, status, message);
    }
  };

  return (
    <div className="h-full overflow-y-auto bg-gray-50 p-4 rounded-b-xl">
      <div className="mx-auto max-w-5xl space-y-5">
        <GoBack props={{ route: userRoutes }} />

        <div className="relative">
          <div className="pointer-events-none absolute -inset-x-6 -top-6 h-24 rounded-3xl bg-gradient-to-r from-emerald-400/15 via-amber-400/15 to-fuchsia-400/15 blur-2xl -z-10" />
          <div className="relative rounded-2xl border border-gray-200 bg-white/90 shadow-sm backdrop-blur">
            <div className="flex items-center justify-between p-5">
              <div>
                <h1 className="text-base font-semibold tracking-tight text-gray-900">
                  Edit User
                </h1>
                <p className="mt-0.5 text-xs text-gray-600">
                  Update profile information and reset password.
                </p>
              </div>
              <div className="hidden sm:flex items-center gap-2">
                <span className="inline-flex items-center gap-2 rounded-full bg-gray-50 px-2.5 py-1 text-[11px] font-medium text-gray-700 ring-1 ring-gray-200">
                  <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                  Active
                </span>
              </div>
            </div>
          </div>
        </div>

        <MyMessage
          error={error || error2}
          message={message || message2}
          success={success || success2}
          onExpired={() => {
            setError(false);
            setSuccess(false);
            setError2(false);
            setSuccess2(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
            setError2(false);
            setSuccess2(false);
            setErrorMessage2("");
          }}
        />

        {/* 1) PROFILE */}
        <form onSubmit={updateOneUserHandler}>
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="p-4 md:p-5">
              <div className="mb-3 flex items-center justify-between">
                <Title props={{ title: "1. Update Profile" }} />
                <div className="hidden sm:block text-[11px] text-gray-500">
                  Fields marked required must be filled
                </div>
              </div>

              <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
                <InputField
                  props={{
                    id: "firstName",
                    title: "First Name",
                    type: "text",
                    value: firstName || "",
                    onChange: (e) => {
                      setFirstName(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <InputField
                  props={{
                    id: "lastName",
                    title: "Last Name",
                    type: "text",
                    value: lastName || "",
                    onChange: (e) => {
                      setLastName(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
                <PhoneInput setPhone={setPhone} phone={phone} required={true} />
                <InputField
                  props={{
                    id: "email",
                    title: "Email Address",
                    type: "email",
                    value: email || "",
                    onChange: (e) => {
                      setPrice(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
              </div>
            </div>

            <div className="border-t border-gray-100 p-4 md:p-5">
              <div className="flex items-center justify-end">
                <MyActionButton
                  loading={loading}
                  title="Update Profile"
                  onClick={() => {
                    setError(false);
                    setSuccess(false);
                    setErrorMessage("");
                    setError2(false);
                    setSuccess2(false);
                    setErrorMessage2("");
                  }}
                />
              </div>
            </div>
          </section>
        </form>

        {/* 2) PASSWORD */}
        <form onSubmit={updatePasswordHandler}>
          <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="p-4 md:p-5">
              <div className="mb-4 flex items-center justify-between">
                <Title props={{ title: "2. Update Password" }} />
                <PasswordTips />
              </div>

              <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
                <PasswordFieldEnhanced
                  label="New Password"
                  value={password}
                  onChange={(v) => {
                    setPassword(v);
                    setError2(false);
                    setSuccess2(false);
                  }}
                />

                <PasswordFieldEnhanced
                  label="Confirm Password"
                  value={confirm_password}
                  onChange={(v) => {
                    setConfirmPassword(v);
                    setError2(false);
                    setSuccess2(false);
                  }}
                />
              </div>

              <PasswordMeta
                password={password}
                confirm={confirm_password}
              />
            </div>

            <div className="border-t border-gray-100 p-4 md:p-5">
              <div className="flex items-center justify-end">
                <MyActionButton
                  loading={loading2}
                  title="Update Password"
                  onClick={() => {
                    setError(false);
                    setSuccess(false);
                    setErrorMessage("");
                    setError2(false);
                    setSuccess2(false);
                    setErrorMessage2("");
                  }}
                />
              </div>
            </div>
          </section>
        </form>
      </div>
    </div>
  );
};

export default Edit;

/* ---------------------------
   Small visual helpers below
----------------------------*/

const PasswordTips = () => (
  <div className="hidden sm:flex items-center gap-2 rounded-full bg-gray-50 px-2.5 py-1 text-[11px] text-gray-700 ring-1 ring-gray-200">
    <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
    Use at least 8 chars with letters, numbers & symbols
  </div>
);

const PasswordMeta = ({ password, confirm }) => {
  const { label, color, percent, checks } = usePasswordStrength(password);
  const matches = password && confirm && password === confirm;

  return (
    <div className="mt-2 grid grid-cols-1 gap-3">
      <div>
        <div className="mb-1.5 flex items-center justify-between text-[11px]">
          <span className="text-gray-600">Strength: {label}</span>
          <span className="text-gray-500">{Math.round(percent)}%</span>
        </div>
        <div className="h-2 w-full rounded-full bg-gray-100 overflow-hidden ring-1 ring-gray-200">
          <div
            className={`h-full ${color}`}
            style={{ width: `${percent}%` }}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-2 text-[11px]">
        {checks.map((c, i) => (
          <span
            key={i}
            className={[
              "inline-flex items-center gap-1 rounded-md px-2 py-1 ring-1",
              c.ok
                ? "bg-emerald-50 text-emerald-700 ring-emerald-200"
                : "bg-gray-50 text-gray-600 ring-gray-200",
            ].join(" ")}
          >
            {c.ok ? <AiOutlineCheck /> : <AiOutlineClose />}
            {c.label}
          </span>
        ))}
        {password || confirm ? (
          <span
            className={[
              "inline-flex items-center gap-1 rounded-md px-2 py-1 ring-1 col-span-2",
              matches
                ? "bg-emerald-50 text-emerald-700 ring-emerald-200"
                : "bg-gray-50 text-gray-600 ring-gray-200",
            ].join(" ")}
          >
            {matches ? <AiOutlineCheck /> : <AiOutlineClose />}
            Passwords match
          </span>
        ) : null}
      </div>
    </div>
  );
};

const PasswordFieldEnhanced = ({ label, value, onChange, required }) => {
  const [show, setShow] = useState(false);
  const [caps, setCaps] = useState(false);

  const toggle = () => setShow((s) => !s);

  const generate = () => {
    const chars =
      "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789!@#$%^&*()_+-=";
    let out = "";
    for (let i = 0; i < 16; i++) out += chars[Math.floor(Math.random() * chars.length)];
    onChange(out);
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value || "");
    } catch { }
  };

  return (
    <div className="space-y-1.5">
      <label className="flex items-center text-xs font-semibold text-gray-800">
        {label}
        {required ? <span className="ml-1 text-red-600">*</span> : null}
      </label>

      <div className="relative">
        <input
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          onKeyUp={(e) => setCaps(e.getModifierState && e.getModifierState("CapsLock"))}
          type={show ? "text" : "password"}
          placeholder={label}
          className={[
            "w-full rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm text-gray-900",
            "placeholder:text-xs placeholder:text-gray-400",
            "shadow-sm focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-200",
          ].join(" ")}
        />

        <div className="absolute inset-y-0 right-2 flex items-center gap-1.5">
          {caps ? (
            <span
              className="mr-1 inline-flex items-center gap-1 rounded-md bg-amber-50 px-2 py-0.5 text-[10px] font-medium text-amber-700 ring-1 ring-amber-200"
              title="Caps Lock is on"
            >
              <AiOutlineWarning /> CAPS
            </span>
          ) : null}

          <button
            type="button"
            onClick={toggle}
            className="grid h-8 w-8 place-items-center rounded-md text-gray-500 hover:text-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
            aria-label={show ? "Hide password" : "Show password"}
            title={show ? "Hide" : "Show"}
          >
            {show ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
          </button>

          <button
            type="button"
            onClick={copy}
            className="grid h-8 w-8 place-items-center rounded-md text-gray-500 hover:text-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
            aria-label="Copy password"
            title="Copy"
          >
            <AiOutlineCopy />
          </button>

          <button
            type="button"
            onClick={generate}
            className="grid h-8 w-8 place-items-center rounded-md text-gray-500 hover:text-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
            aria-label="Generate strong password"
            title="Generate"
          >
            <AiOutlineReload />
          </button>
        </div>
      </div>
    </div>
  );
};

function usePasswordStrength(pwd) {
  const scoreObj = useMemo(() => {
    const checks = [
      { label: "≥ 8 characters", ok: (pwd || "").length >= 8 },
      { label: "Uppercase", ok: /[A-Z]/.test(pwd || "") },
      { label: "Lowercase", ok: /[a-z]/.test(pwd || "") },
      { label: "Number", ok: /\d/.test(pwd || "") },
      { label: "Symbol", ok: /[^A-Za-z0-9]/.test(pwd || "") },
    ];
    const count = checks.filter((c) => c.ok).length;
    const map = [
      { label: "Very Weak", color: "bg-red-400", percent: 10 },
      { label: "Weak", color: "bg-orange-400", percent: 30 },
      { label: "Fair", color: "bg-amber-400", percent: 55 },
      { label: "Good", color: "bg-lime-500", percent: 75 },
      { label: "Strong", color: "bg-emerald-500", percent: 90 },
      { label: "Excellent", color: "bg-emerald-600", percent: 100 },
    ];
    const idx = Math.min(count, map.length - 1);
    return { score: count, ...map[idx], checks };
  }, [pwd]);

  return scoreObj;
}
